import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useRouter } from "next/router";

function HfnIframe(props) {
  const { Title, Iframe_Url: IframeUrl, AllowFullScreen } = props;

  const router = useRouter();

  // Getting domain name from fully qualified url
  const domain = new URL(IframeUrl);
  const allowedUrl = domain.origin;

  useEffect(() => {
    const handleEvent = (event) => {
      const { data, origin } = event;
      if (origin === allowedUrl) {
        if (data && data.url) {
          router.push(data.url);
        }
      }
    };
    window.addEventListener("message", handleEvent, false);
    return function cleanup() {
      window.removeEventListener("message", handleEvent);
    };
  }, []);

  return (
    <iframe
      id="HfnIframe"
      title={Title}
      src={IframeUrl}
      allowFullScreen={AllowFullScreen}
      border={0}
      scrolling="true"
      target="_parent"
    />
  );
}

// Specifies the default values for props:
HfnIframe.defaultProps = {
  AllowFullScreen: true,
};

HfnIframe.propTypes = {
  Title: PropTypes.string.isRequired,
  Iframe_Url: PropTypes.string.isRequired,
  AllowFullScreen: PropTypes.bool,
};

export default HfnIframe;
